import { z } from 'zod';
import { EnglishTestSchema, StudySchema } from '../applicant';
import { PassportSchema } from '../shared';

export const DocumentFulfilmentSchema = z.object({
  sKey: z.string(),
  s3Key: z.string(),
  urls: z.array(z.string()).optional(),
  linkText: z.string().optional()
});

export const TextFulfilmentSchema = z.object({
  text: z.string().optional(),
  subtext: z.string().optional()
});

export const PassportFulfilmentSchema = DocumentFulfilmentSchema;

export const OfferPassportSchema = PassportFulfilmentSchema.extend({
  passport: PassportSchema,
  fileName: z.string().min(1, { message: 'File is required' })
});

export const AcademicResultFulfilmentSchema = z.object({
  studyHistory: StudySchema
});

export const EnglishResultsFulfilmentSchema = z.object({
  englishTest: EnglishTestSchema
});

/* eslint-disable @typescript-eslint/no-empty-object-type */

export interface IDocumentFulfilmentData extends z.infer<typeof DocumentFulfilmentSchema> {}
export interface ITextFulfilmentData extends z.infer<typeof TextFulfilmentSchema> {}

export interface IPassportFulfilmentData extends z.infer<typeof PassportFulfilmentSchema> {}
export interface IAcademicResultFulfilmentData extends z.infer<typeof AcademicResultFulfilmentSchema> {}
export interface IEnglishResultsFulfilmentData extends z.infer<typeof EnglishResultsFulfilmentSchema> {}

export interface IOfferPassportData extends z.infer<typeof OfferPassportSchema> {}
